import colors from 'assets/scss/colors.module.scss';

export type AspKategorie = 'Vorsorge & Anlage' | 'Privat Sach' | 'Firmen Sach';

export const AspKategorien: AspKategorie[] = ['Vorsorge & Anlage', 'Privat Sach', 'Firmen Sach'];

// zweite Kategorie-Dimension: Impulse überlappen die Kategorien (JPG gruppiert nach Impuls, Potentialliste nach Kategorie)
export type AspImpuls = 'Automatisierter Vertriebsimpuls' | 'Aktivierender Steuerungsimpuls' | 'Entwicklungsimpuls';

export const AspImpulse: AspImpuls[] = ['Automatisierter Vertriebsimpuls', 'Aktivierender Steuerungsimpuls', 'Entwicklungsimpuls'];

// css-Modifier, Farben siehe asp-design.scss
export const aspKategorieModifier: Record<AspKategorie, string> = {
	'Vorsorge & Anlage': 'is-asp-vorsorge-anlage',
	'Privat Sach': 'is-asp-privat-sach',
	'Firmen Sach': 'is-asp-firmen-sach',
};

export const aspImpulsModifier: Record<AspImpuls, string> = {
	'Automatisierter Vertriebsimpuls': 'is-asp-vertriebsimpuls',
	'Aktivierender Steuerungsimpuls': 'is-asp-steuerungsimpuls',
	Entwicklungsimpuls: 'is-asp-entwicklungsimpuls',
};

// Hintergrund-Helper der Tabelle (table.scss), passend zu den Kategoriefarben
export const aspKategorieBg: Record<AspKategorie, string> = {
	'Vorsorge & Anlage': 'bg-green',
	'Privat Sach': 'bg-purple',
	'Firmen Sach': 'bg-blue',
};

// Rahmen-Helper der Tabelle (table.scss) für die erste Spalte einer Kategorie
export const aspKategorieBorder: Record<AspKategorie, string> = {
	'Vorsorge & Anlage': 'border-left-green',
	'Privat Sach': 'border-left-purple',
	'Firmen Sach': 'border-left-blue',
};

export interface IAspCampaign {
	id: string;
	name: string;
	nameShort: string;
	kategorie: AspKategorie;
	impuls: AspImpuls;
	start: Date;
	end: Date;
}

export const ASP_YEAR = 2026;

// Vorbereitungs-/Trainingsphase: ca. 2 Wochen vor Kampagnenstart
export const aspPrepStart = (c: IAspCampaign) => {
	const d = new Date(c.start);
	d.setDate(d.getDate() - 14);
	return d;
};

export const ASP_CAMPAIGNS: IAspCampaign[] = [
	// Vorsorge & Anlage
	{
		id: 'va-existenz',
		name: 'Existenzabsicherung',
		nameShort: 'Existenz',
		kategorie: 'Vorsorge & Anlage',
		impuls: 'Automatisierter Vertriebsimpuls',
		start: new Date(ASP_YEAR, 0, 12),
		end: new Date(ASP_YEAR, 2, 6),
	},
	{
		id: 'va-pflege',
		name: 'Pflege',
		nameShort: 'Pflege',
		kategorie: 'Vorsorge & Anlage',
		impuls: 'Automatisierter Vertriebsimpuls',
		start: new Date(ASP_YEAR, 1, 9),
		end: new Date(ASP_YEAR, 3, 17),
	},
	{
		id: 'va-plan12',
		name: 'Plan 12',
		nameShort: 'Plan 12',
		kategorie: 'Vorsorge & Anlage',
		impuls: 'Automatisierter Vertriebsimpuls',
		start: new Date(ASP_YEAR, 2, 2),
		end: new Date(ASP_YEAR, 4, 22),
	},
	{
		id: 'va-kinder',
		name: 'Kinder',
		nameShort: 'Kinder',
		kategorie: 'Vorsorge & Anlage',
		impuls: 'Automatisierter Vertriebsimpuls',
		start: new Date(ASP_YEAR, 3, 13),
		end: new Date(ASP_YEAR, 5, 26),
	},
	{
		id: 'va-kleinbetriebe',
		name: 'Kleinbetriebe',
		nameShort: 'Kleinbetriebe',
		kategorie: 'Vorsorge & Anlage',
		impuls: 'Aktivierender Steuerungsimpuls',
		start: new Date(ASP_YEAR, 4, 11),
		end: new Date(ASP_YEAR, 6, 24),
	},
	{
		id: 'va-junge-erwachsene',
		name: 'Junge Erwachsene',
		nameShort: 'Junge Erw.',
		kategorie: 'Vorsorge & Anlage',
		impuls: 'Aktivierender Steuerungsimpuls',
		start: new Date(ASP_YEAR, 5, 8),
		end: new Date(ASP_YEAR, 7, 14),
	},
	{
		id: 'va-eb-impuls',
		name: 'EB-Impuls Fortführung 2026',
		nameShort: 'EB-Impuls',
		kategorie: 'Vorsorge & Anlage',
		impuls: 'Aktivierender Steuerungsimpuls',
		start: new Date(ASP_YEAR, 7, 3),
		end: new Date(ASP_YEAR, 9, 9),
	},
	{
		id: 'va-kapitalmarkt',
		name: 'Kapitalmarktexpertise',
		nameShort: 'Kapitalmarkt',
		kategorie: 'Vorsorge & Anlage',
		impuls: 'Entwicklungsimpuls',
		start: new Date(ASP_YEAR, 8, 7),
		end: new Date(ASP_YEAR, 10, 13),
	},
	{
		id: 'va-bv',
		name: 'Fokusinitiative bV',
		nameShort: 'Fokus bV',
		kategorie: 'Vorsorge & Anlage',
		impuls: 'Entwicklungsimpuls',
		start: new Date(ASP_YEAR, 9, 5),
		end: new Date(ASP_YEAR, 11, 18),
	},
	// Privat Sach
	{
		id: 'ps-kennzeichen',
		name: 'Versicherungskennzeichen',
		nameShort: 'Kennzeichen',
		kategorie: 'Privat Sach',
		impuls: 'Automatisierter Vertriebsimpuls',
		start: new Date(ASP_YEAR, 0, 5),
		end: new Date(ASP_YEAR, 1, 27),
	},
	{
		id: 'ps-einstieg',
		name: 'Einstiegsprodukte',
		nameShort: 'Einstieg',
		kategorie: 'Privat Sach',
		impuls: 'Automatisierter Vertriebsimpuls',
		start: new Date(ASP_YEAR, 4, 4),
		end: new Date(ASP_YEAR, 6, 31),
	},
	{
		id: 'ps-jahresendspurt',
		name: 'Jahresendspurt P-Sach',
		nameShort: 'Jahresendspurt',
		kategorie: 'Privat Sach',
		impuls: 'Automatisierter Vertriebsimpuls',
		start: new Date(ASP_YEAR, 9, 1),
		end: new Date(ASP_YEAR, 11, 18),
	},
	// Firmen Sach
	{
		id: 'fs-smc',
		name: 'SMC',
		nameShort: 'SMC',
		kategorie: 'Firmen Sach',
		impuls: 'Aktivierender Steuerungsimpuls',
		start: new Date(ASP_YEAR, 1, 16),
		end: new Date(ASP_YEAR, 4, 8),
	},
	{
		id: 'fs-midcorp',
		name: 'MidCorp',
		nameShort: 'MidCorp',
		kategorie: 'Firmen Sach',
		impuls: 'Aktivierender Steuerungsimpuls',
		start: new Date(ASP_YEAR, 5, 15),
		end: new Date(ASP_YEAR, 8, 4),
	},
	{
		id: 'fs-exzellenz',
		name: 'Exzellenz-Netzwerk Firmen',
		nameShort: 'Exzellenz-Netzwerk',
		kategorie: 'Firmen Sach',
		impuls: 'Entwicklungsimpuls',
		start: new Date(ASP_YEAR, 8, 14),
		end: new Date(ASP_YEAR, 10, 27),
	},
];

export const campaignsByKategorie = (kategorie: AspKategorie) => ASP_CAMPAIGNS.filter((c) => c.kategorie === kategorie);

export const campaignsByImpuls = (impuls: AspImpuls) => ASP_CAMPAIGNS.filter((c) => c.impuls === impuls);

export interface IAspAgt {
	agtId: number;
	name: string;
}

// Art der Zuweisung einer Kampagne: durch die Agentur selbst oder über DSE
export type AspZuweisung = 'Agentur' | 'DSE';

// Tag-Farben (tag.scss), um die Art der Zuweisung zu unterscheiden
export const aspZuweisungTagModifier: Record<AspZuweisung, string> = {
	Agentur: 'is-primary',
	'DSE': 'is-info',
};

export interface IAspAgtPotenzial {
	agt: IAspAgt;
	// campaignId -> identifizierte Kunden mit Interesse
	potenziale: Record<string, number>;
	// campaignId -> Art der Zuweisung, an der die Agentur bereits teilnimmt
	teilnahmen: Record<string, AspZuweisung>;
	// die 5 Aktionen mit dem höchsten Potenzial dieser Agentur
	top5: string[];
}

const SAMPLE_AGTS: IAspAgt[] = [
	{ agtId: 47119024, name: 'Müller & Partner OHG' },
	{ agtId: 47118856, name: 'Allianz Generalvertretung Berger' },
	{ agtId: 47120113, name: 'Schneider Versicherungen e.K.' },
	{ agtId: 47119987, name: 'Hofmann Agentur' },
	{ agtId: 47118402, name: 'Weber & Söhne GbR' },
	{ agtId: 47120441, name: 'Becker Vertretung' },
	{ agtId: 47119215, name: 'Klein Agentur München-Süd' },
	{ agtId: 47118770, name: 'Wagner & Co. KG' },
	{ agtId: 47120098, name: 'Fischer Versicherungsbüro' },
	{ agtId: 47119553, name: 'Schmidt Generalagentur' },
	{ agtId: 47120556, name: 'Krause & Bauer KG' },
	{ agtId: 47119880, name: 'Neumann Versicherungsmakler' },
];

// deterministische "Zufallszahlen" im realistischen Bereich 20-150
const mockPotenzial = (agtIndex: number, campaignIndex: number) => 20 + ((agtIndex * 37 + campaignIndex * 53 + 11) % 131);

const buildTop5 = (potenziale: Record<string, number>) =>
	Object.entries(potenziale)
		.sort((a, b) => b[1] - a[1])
		.slice(0, 5)
		.map(([id]) => id);

export const buildAspPotenzialListe = (): IAspAgtPotenzial[] => {
	return SAMPLE_AGTS.map((agt, i) => {
		const potenziale: Record<string, number> = {};
		ASP_CAMPAIGNS.forEach((c, j) => {
			potenziale[c.id] = mockPotenzial(i, j);
		});
		const top5 = buildTop5(potenziale);
		// jede Agentur nimmt bereits an 1-3 Aktionen teil, teils mit hohem, teils mit niedrigem Potenzial
		const teilnahmen: Record<string, AspZuweisung> = {};
		teilnahmen[ASP_CAMPAIGNS[i % ASP_CAMPAIGNS.length].id] = i % 2 === 0 ? 'Agentur' : 'DSE';
		teilnahmen[top5[i % 3 === 0 ? 0 : 3]] = 'Agentur';
		if (i % 4 === 0) {
			teilnahmen[ASP_CAMPAIGNS[(i + 5) % ASP_CAMPAIGNS.length].id] = 'DSE';
		}
		return {
			agt,
			potenziale,
			teilnahmen,
			top5,
		};
	});
};

// Mock-Zeilen für die "normale" Agenturliste hinter dem Detail-Panel (VBL-Sicht, vgl. VblAgenturListCols)
export interface IAspAgtFokusThema {
	short: string;
	background: string;
	color?: string;
}

export interface IAspAgtListRow {
	agt: IAspAgt;
	gp: string;
	fokusthemen: IAspAgtFokusThema[];
	bpMine: { count: number; total: number };
	bpSpezi: { count: number; total: number };
	schwerpunkt: string[];
}

// Farben analog zu den Fokusthemen-Definitionen (JpgFocusThemenDef2026)
const FOKUS_THEMEN_POOL: IAspAgtFokusThema[] = [
	{ short: 'GUP', background: colors.green, color: colors.white },
	{ short: 'AMIS.NOW', background: colors.turquoise, color: colors.white },
	{ short: 'AKUMA', background: colors.yellow },
	{ short: 'MAZ', background: colors.primary, color: colors.white },
	{ short: 'S2S', background: colors.turquoise, color: colors.white },
	{ short: 'KVM', background: colors.primary, color: colors.white },
];

// Variante 70 ist die häufigste GP-Variante
const GP_POOL = ['Variante 70', 'Variante 70', 'Pro3', 'Variante 90', 'Variante 70', 'Variante 50'];

const SCHWERPUNKT_POOL = ['VAS', 'KVS', 'UB', 'BSG'];

export const buildAspAgtListe = (): IAspAgtListRow[] =>
	SAMPLE_AGTS.map((agt, i) => {
		const fokusthemen = [FOKUS_THEMEN_POOL[i % FOKUS_THEMEN_POOL.length], FOKUS_THEMEN_POOL[(i + 2) % FOKUS_THEMEN_POOL.length], FOKUS_THEMEN_POOL[(i + 4) % FOKUS_THEMEN_POOL.length]].slice(
			0,
			1 + (i % 3),
		);
		const schwerpunkt = [SCHWERPUNKT_POOL[i % SCHWERPUNKT_POOL.length], SCHWERPUNKT_POOL[(i + 1) % SCHWERPUNKT_POOL.length]].slice(0, i % 3);
		return {
			agt,
			gp: GP_POOL[i % GP_POOL.length],
			fokusthemen,
			bpMine: { count: 4 + (i % 5), total: 8 },
			bpSpezi: { count: 1 + (i % 4), total: 5 },
			schwerpunkt,
		};
	});

export const formatAspDate = (d: Date) => d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
export const formatAspDateShort = (d: Date) => d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' });
